class Address {
    addressId = 0
    address1 = ''
    address2 = ''
    city = ''
    country = ''
    state = ''
    zipCode = ''
    phone1 = ''
    phone2 = ''
    citizenshipCountryCode = ''
    stateCode = ''
    countryCode = ''
    constructor(data) {
        Object.assign(this, data);
    }

    isEmpty() {
        return !this.address1 && !this.address2 && !this.city && !this.country && !this.state && !this.zipCode && !this.phone1 && !this.phone2;
    }

    toJSON() {
        return { ...this };
    }
}

export default Address;